export default {
    OrderPostage: {
        name: 'File Name',
        time: 'Invoice Generation Time',
        type: 'Type',
        create: 'Creation Time',
        not: 'Mismatched Project',
        order: 'Waybill Number',
        price: 'Invoice Price',
        yet: 'Match Project',
        outer: 'Platform Order Number',
        logitisic: 'Logistics Waybill Number',
        lose: 'Percentage Difference',
        over: 'Difference',
        total: 'Total Price',
        pay: 'Total Invoice Amount',
        fee: 'Invoice Charge Details',
        Freight: 'Freight',
        tax: 'Freight Tax',
        cost: 'Fuel Fee',
        Fuel: 'Fuel Tax',
        ERP: 'ERP Charge Details',
        Totals: 'Total Tax Amount',
        amount: 'Total Amount',
        diff: 'The Difference Exceeds',
        after: 'Total Pre Tax Amount',
        ExtraTax: 'Extra fee (excl. GST)',
        taxsurcharge: 'Overweight fee (excl. GST)',
        taxextra: 'Excess length fee (excl. GST)',
        taxreturn: 'Return and reissue fee (excl. GST)',
        invoiceNotes: 'Notes',
    },
    IntegratedPage: {
        id: 'Product ID',
        name: 'Product Name',
        key: 'Keywords',
        rank: 'Ranking',
        sale: 'Seller',
        type: 'Type',
        typeS: 'Sales Type',
        self: 'Link',
        doll: 'Amount Of Money',
        dollS: 'Amount Unit',
        save: 'Save Money',
        saveS: 'Unit Of Saved Amount',
        star: 'Star Rating',
        num: 'Number Of Comments',
        typeSS: 'Special Type',
    }
};
